import { render } from "./AbbonnementView.vue?vue&type=template&id=1d89ceca"
import script from "./AbbonnementView.vue?vue&type=script&lang=js"
export * from "./AbbonnementView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__